/**
 * Created by lobin on 2019/1/21.
 */
import { request } from "../../plugins/axios";
const state = {
  screening: []
};
const getters = {};
const actions = {
  /**
   * 获取首页筛选条件
   * @param data
   * @return {Promise.<void>}
   */
  async getScreeningConditions({ commit, dispatch }) {
    const hotCity = await dispatch("getHotCity");
    const tagList = await dispatch("getTagList");
    const { data } = await request({
      url: "/portal/dictionaries/",
      params: {
        codes: "103,105,108,230"
      }
    });
    const tagData = tagList.concat(data);
    const allData = hotCity.concat(tagData);
    for (let item of allData) {
      item.children.unshift({
        code: "",
        name: "全部",
        parentCode: 104,
        rank: 1,
        type: item.type
      });
    }
    commit("setState", { key: "screening", data: allData });
    return true;
  },
  /**
   * 获取首页筛选热门城市
   * @param data
   * @return {Promise.<void>}
   */
  async getHotCity({}) {
    const { data } = await request({ url: "/portal/position/area" });
    for (let item of data) {
      item.type = "cityCode";
    }
    return [
      {
        name: "热门城市",
        children: data,
        code: 12,
        parentCode: 0,
        rank: 2,
        type: "cityCode"
      }
    ];
  },
  /**
   * 获取首页筛选标签数据
   * @param data
   * @return {Promise.<void>}
   */
  async getTagList({}) {
    const { data } = await request({
      url: "/portal/label/findLabelNameList?type=3&pageSize=100"
    });
    let tagList = [];
    for (let item of data) {
      let tagData = {};
      tagData.code = item.code;
      tagData.name = item.value;
      tagData.type = "positionLabel";
      tagList.push(tagData);
    }
    return [
      {
        name: "职位标签",
        children: tagList,
        code: 13,
        parentCode: 1,
        rank: 20,
        type: "positionLabel"
      }
    ];
  }
};
const mutations = {
  setState(state, { key, data }) {
    state[key] = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
